module.exports = __webpack_public_path__ + "assets/30a4c23e954bbe767abb82f7fcdcbbf5.png";